<template>
  <van-nav-bar @click-left="goBack" left-arrow>
    <template #left>
      <div class="left-container">
        <van-badge :content="chatOtherTotalNewCount || null">
          <i
            class="
              van-badge__wrapper
              van-icon van-icon-arrow-left
              van-nav-bar__arrow
            "
          ></i>
          <span class="return-text">返回</span>
        </van-badge>
      </div>
    </template>

    <template #title>
      <div class="title-slot">
        <span class="title-container">
          {{ currentVisitor?.name || currentVisitor?.nickname }}
          <template v-if="currentVisitor?.feLocation"
            >({{ currentVisitor?.feLocation }})</template
          >
        </span>

        <chat-page-subtitle></chat-page-subtitle>
      </div>

      <!-- template -->
    </template>
  </van-nav-bar>

  <div class="top-action-panel">
    <div class="top-action" @click="showDialog = true">访客来源</div>
    <div class="top-action" @click="editLead">编辑客资</div>
    <div class="top-action" @click="openTransfer">转接对话</div>
    <div class="top-action" @click="report">举报拉黑</div>
  </div>

  <div
    ref="messageList"
    class="message-list"
    @click="closePanel"
    @scroll.passive="onMessageListScroll"
    v-bind:style="{
      bottom: inputContainerHeight + 'px',
    }"
    v-chat-scroll="{ always: false, smooth: true }"
  >
    <div v-if="chatScrollFix"></div>
    <div
      v-if="messageListTopSpacerHeight"
      class="message-list-top-spacer"
      :style="{ height: messageListTopSpacerHeight + 'px' }"
    ></div>
    <yunque-message
      v-for="message in historyConversation"
      :message="message"
      :key="message.microtime"
      :data-message-microtime="messageDomMicrotime(message)"
      :class="{ 'message-target-highlight': isTargetMessage(message) }"
      @onResend="resendMessage"
    ></yunque-message>
    <yunque-message
      v-for="message in currentVisitor?.conversation"
      :message="message"
      :key="message.microtime"
      :data-message-microtime="messageDomMicrotime(message)"
      :class="{ 'message-target-highlight': isTargetMessage(message) }"
      @onResend="resendMessage"
    ></yunque-message>
  </div>

  <button
    v-show="showScrollToBottomButton"
    class="scroll-to-bottom-button"
    :style="{ bottom: inputContainerHeight + 16 + 'px' }"
    type="button"
    aria-label="滚动到底部"
    @click.stop="handleScrollToBottomClick"
  >
    <span class="scroll-to-bottom-icon-stack" aria-hidden="true">
      <i class="van-icon van-icon-arrow-down"></i>
      <i class="van-icon van-icon-arrow-down"></i>
    </span>
  </button>

  <message-input></message-input>

  <van-popup v-model:show="showTransferPicker" position="bottom">
    <van-picker
      title="转接对话"
      :columns="workerList"
      @confirm="onTransfer"
      @cancel="showTransferPicker = false"
      :default-index="0"
    />
  </van-popup>

  <van-dialog v-model:show="showDialog">
    <source-dialog> </source-dialog>
  </van-dialog>

  <van-dialog
    v-model:show="showReportDialog"
    title="举报拉黑"
    show-cancel-button
    confirmButtonText="确定"
    cancelButtonText="取消"
    @confirm="doReport"
    @cancel="showReportDialog = false"
  >
    <div style="padding: 20px; display: flex; margin-left: 60px;">
      <van-checkbox v-model="isReportAndBlock">拉黑并关闭对话</van-checkbox>
    </div>

    <div style="padding: 0 20px 20px 20px; display: flex; margin-left: 60px;">
      <van-checkbox v-model="isReportPlaceholder">举报广告骚扰、其他违规</van-checkbox>
    </div>

    <div style="padding: 0 20px 20px 20px; display: flex; margin-left: 60px;">
      <van-checkbox v-model="isReportLegal">举报黄赌毒、政治敏感</van-checkbox>
    </div>
  </van-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters, mapState } from "vuex";
import Message from "@/components/messages/Message.vue";
import MessageInput from "@/components/MessageInput.vue";
import ChatPageSubtitle from "@/components/ChatPageSubtitle.vue";
import SourceDialog from "@/components/SourceDialog.vue";
import {
  getDouyinHistoryDetail,
  getWebHistoryDetail,
  getWechatHistoryDetail,
  getWeiboHistoryDetail,
  getKuaishouHistoryDetail,
  getRedbookuHistoryDetail,
} from "@/api/history";
import { getOnlineWorkers, transfer, callReport } from "@/api/common";
import CommetFactory from "@/api/CommetFactory";

import { NavBar, Badge, Toast, Popup, Picker, Dialog, Checkbox, Notify} from "vant";

export default defineComponent({
  components: {
    [NavBar.name]: NavBar,
    [Badge.name]: Badge,
    "yunque-message": Message,
    "message-input": MessageInput,
    "chat-page-subtitle": ChatPageSubtitle,
    "source-dialog": SourceDialog,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      historyConversation: [],
      chatScrollFix: false,
      showTransferPicker: false,
      workerList: [],
      showDialog: false,
      showReportDialog: false,
      isReportAndBlock: true,
      isReportLegal: false,
      isReportPlaceholder: false,
      hasEarlierHistory: true,
      earlierHistoryMicrotime: null,
      loadingEarlierHistory: false,
      hasLaterHistory: false,
      laterHistoryMicrotime: null,
      loadingLaterHistory: false,
      loadingLatestHistory: false,
      suppressEarlierHistoryAutoLoad: false,
      autoLoadThreshold: 40,
      showScrollToBottomButton: false,
      scrollToBottomButtonThreshold: 120,
      messageListTopSpacerHeight: 0,
    };
  },

  computed: {
    ...mapGetters({
      currentVisitor: "currentVisitor",
      chatOtherTotalNewCount: "chatOtherTotalNewCount",
      toReplyCMT: "toReplyCMT",
    }),

    ...mapState({
      otherTotalNewCount: (state) => state.chat.otherTotalNewCount,
      wechatApps: (state) => state.common.wechatAppsObj,
      weiboApps: (state) => state.common.weiboAppsObj,
      douyinApps: (state) => state.common.douyinAppsObj,
      kuaishouApps: (state) => state.common.kuaishouAppsObj,
      redbookApps: (state) => state.common.redbookAppsObj,
      companyID: (state) => state.auth.companyID,
      inputContainerHeight: (state) => state.chat.inputContainerHeight,
    }),
  },

  watch: {
    async currentVisitor(newVisitor, oldVisitor) {
      if (!this.currentVisitor) {
        this.$router.replace("/chat-list");
      } else {
        if (newVisitor?.uid !== oldVisitor?.uid) {
          this.historyConversation = [];
          this.resetEarlierHistoryState();
          await this.loadInitialHistory();
          return;
        }
      }
    },

    "$route.query.microtime"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.reloadHistoryFromRouteTarget();
    },
  },

  beforeMount() {
    this.$store.commit("SET_CURRENT_VISITOR", this.$route.query.uid);
    this.$store.commit("UPDATE_INPUT_PULLEDUP", false);
  },

  async mounted() {
    if (!this.currentVisitor) {
      this.$router.replace("/chat-list");
    } else {
      await this.loadInitialHistory();
    }
  },

  beforeUnmount() {
    this.$store.commit("UPDATE_TO_REPLY_CMT", null);
  },

  methods: {
    goBack() {
      if (this.isFromChatSearch()) {
        this.goBackToChatSearch();
        return;
      }

      this.$router.push("/chat-list");
    },

    routeQueryText(value) {
      const raw = Array.isArray(value) ? value[0] : value;
      return String(raw || "").trim();
    },

    routeQueryParam(key) {
      const routeValue = this.routeQueryText(this.$route.query[key]);
      if (routeValue) return routeValue;
      return new URLSearchParams(window.location.search).get(key) || "";
    },

    isFromChatSearch() {
      return (
        this.routeQueryParam("from") === "chatSearch" ||
        window.location.href.includes("from=chatSearch")
      );
    },

    chatSearchReturnLocation() {
      const q = this.routeQueryParam("searchQ");
      const tab = this.routeQueryParam("searchTab");
      const query = {};

      if (q) {
        query.q = q;
      }
      if (tab === "visitor") {
        query.tab = "visitor";
      }

      return {
        name: "chatSearch",
        query,
      };
    },

    goBackToChatSearch() {
      this.$router.replace(this.chatSearchReturnLocation());
    },

    closePanel() {
      this.$store.commit("UPDATE_INPUT_PULLEDUP", false);
      this.$store.commit("RESET_INPUT_PULLUP_HEIGHT");
    },

    resetEarlierHistoryState() {
      this.hasEarlierHistory = true;
      this.earlierHistoryMicrotime = null;
      this.loadingEarlierHistory = false;
      this.hasLaterHistory = false;
      this.laterHistoryMicrotime = null;
      this.loadingLaterHistory = false;
      this.loadingLatestHistory = false;
      this.suppressEarlierHistoryAutoLoad = false;
      this.showScrollToBottomButton = false;
      this.messageListTopSpacerHeight = 0;
    },

    updateEarlierHistoryMeta(res) {
      this.hasEarlierHistory = Boolean(res.hasEarlierHistory);
      this.earlierHistoryMicrotime = this.hasEarlierHistory
        ? this.normalizeMicrotime(res.earlierHistoryMicrotime)
        : null;
    },

    updateLaterHistoryMeta(res) {
      this.hasLaterHistory = Boolean(res.hasLaterHistory);
      this.laterHistoryMicrotime = this.hasLaterHistory
        ? this.normalizeMicrotime(res.laterHistoryMicrotime)
        : null;
    },

    lastHistoryMessageMicrotime() {
      const lastMessage = this.historyConversation[this.historyConversation.length - 1];
      return this.messageDomMicrotime(lastMessage);
    },

    prepareLaterHistoryAutoLoad() {
      const microtime = this.lastHistoryMessageMicrotime();
      this.hasLaterHistory = Boolean(microtime);
      this.laterHistoryMicrotime = microtime || null;
    },

    async loadInitialHistory() {
      const targetMicrotime = this.routeTargetMicrotime();
      this.suppressEarlierHistoryAutoLoad = true;

      try {
        const loaded = await this.loadEarlierHistory({
          preserveScroll: false,
          microtime: targetMicrotime || undefined,
          includeCursor: targetMicrotime ? 1 : 0,
        });
        if (targetMicrotime && loaded) {
          this.prepareLaterHistoryAutoLoad();
        }

        await this.scrollMessageListToBottomAfterLayout();

        if (targetMicrotime) {
          this.onMessageListScroll();
        } else {
          await this.loadEarlierHistoryUntilScrollable();
          await this.scrollMessageListToBottomAfterLayout();
        }
      } finally {
        this.suppressEarlierHistoryAutoLoad = false;
      }
    },

    async reloadHistoryFromRouteTarget() {
      if (!this.currentVisitor) return;

      this.historyConversation = [];
      this.resetEarlierHistoryState();
      await this.loadInitialHistory();
    },

    createHistoryRequest(
      last_id,
      direction = "early",
      includeCursor = 0,
      includeRealtime = 0
    ) {
      let obs;
      const pageDirection = direction || "early";

      switch (this.currentVisitor?.platform) {
        case "web":
          obs = getWebHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            this.companyID,
            pageDirection,
            includeRealtime,
            includeCursor
          );
          break;
        case "wechat":
          obs = getWechatHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            pageDirection,
            includeRealtime,
            includeCursor
          );
          break;

        case "weibo":
          obs = getWeiboHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            pageDirection,
            includeRealtime,
            includeCursor
          );

          break;
        case "douyin":
          obs = getDouyinHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            pageDirection,
            includeRealtime,
            includeCursor
          );
          break;
        case "kuaishou":
          obs = getKuaishouHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            pageDirection,
            includeRealtime,
            includeCursor
          );
          break;
        case "redbook":
          obs = getRedbookuHistoryDetail(
            this.currentVisitor.uid,
            last_id,
            pageDirection,
            includeRealtime,
            includeCursor
          );
          break;

        default:
          break;
      }

      return obs;
    },

    fetchHistory(last_id, direction = "early", includeCursor = 0) {
      const obs = this.createHistoryRequest(last_id, direction, includeCursor);

      return new Promise((resolve) => {
        if (!obs) {
          resolve(null);
          return;
        }

        obs.subscribe((res) => {
          this.chatScrollFix = true;
          resolve(res);
        }, () => {
          resolve(null);
        });
      });
    },

    async getHistory(last_id, direction = "early", includeCursor = 0) {
      const pageDirection = direction || "early";
      const res = await this.fetchHistory(last_id, pageDirection, includeCursor);

      if (!res) {
        return false;
      }

      if (pageDirection === "later") {
        this.updateLaterHistoryMeta(res);
      } else {
        this.updateEarlierHistoryMeta(res);
      }

      if (!res.data.length) {
        return false;
      }

      if (pageDirection === "later") {
        this.historyConversation = this.historyConversation.concat(
          res.data.slice()
        );
      } else {
        this.historyConversation = res.data
          .slice()
          .concat(this.historyConversation);
      }

      return true;
    },

    normalizeMicrotime(value) {
      const raw = Array.isArray(value) ? value[0] : value;
      return String(raw ?? "").trim();
    },

    routeTargetMicrotime() {
      return this.normalizeMicrotime(this.$route.query.microtime);
    },

    messageDomMicrotime(message) {
      return this.normalizeMicrotime(
        message?.originalMicrotime ?? message?.microtime ?? message?.cmicrotime
      );
    },

    messageMicrotimeValues(message) {
      return [message?.originalMicrotime, message?.microtime, message?.cmicrotime]
        .map((value) => this.normalizeMicrotime(value))
        .filter(Boolean);
    },

    isTargetMessage(message) {
      const targetMicrotime = this.routeTargetMicrotime();
      return (
        !!targetMicrotime &&
        this.messageMicrotimeValues(message).includes(targetMicrotime)
      );
    },

    getMessageListElement() {
      return this.$refs.messageList || null;
    },

    scrollMessageListToBottom() {
      const list = this.getMessageListElement();
      if (!list) return;
      list.scrollTop = list.scrollHeight;
      this.updateScrollToBottomButtonVisibility(list);
    },

    waitForMessageListLayout() {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => resolve());
        });
      });
    },

    async scrollMessageListToBottomAfterLayout() {
      this.messageListTopSpacerHeight = 0;
      await this.$nextTick();
      await this.waitForMessageListLayout();
      const list = this.getMessageListElement();
      if (list) {
        this.messageListTopSpacerHeight = Math.max(
          list.clientHeight - list.scrollHeight,
          0
        );
      }
      await this.$nextTick();
      await this.waitForMessageListLayout();
      this.scrollMessageListToBottom();
      await this.waitForMessageListLayout();
      this.scrollMessageListToBottom();
    },

    async restoreMessageListScrollTop(el, scrollTop) {
      await this.$nextTick();
      el.scrollTop = scrollTop;
      await this.waitForMessageListLayout();
      el.scrollTop = scrollTop;
      this.updateScrollToBottomButtonVisibility(el);
    },

    messageListItems(el) {
      return Array.from(el.children).filter((child) =>
        child.classList?.contains("message-container")
      );
    },

    messageListAnchor(el) {
      const listTop = el.getBoundingClientRect().top;
      const element =
        this.messageListItems(el).find(
          (item) => item.getBoundingClientRect().bottom > listTop
        ) || null;

      if (!element) return null;

      return {
        element,
        top: element.getBoundingClientRect().top,
      };
    },

    async restoreMessageListAnchor(
      el,
      anchor,
      fallbackScrollHeight,
      fallbackScrollTop
    ) {
      const restore = () => {
        if (anchor?.element?.isConnected) {
          const currentTop = anchor.element.getBoundingClientRect().top;
          el.scrollTop += currentTop - anchor.top;
          return;
        }

        el.scrollTop = el.scrollHeight - fallbackScrollHeight + fallbackScrollTop;
      };

      await this.$nextTick();
      restore();
      await this.waitForMessageListLayout();
      restore();
      this.updateScrollToBottomButtonVisibility(el);
    },

    messageListDistanceToBottom(el) {
      return Math.max(el.scrollHeight - el.scrollTop - el.clientHeight, 0);
    },

    isNearMessageListTop(el) {
      return el.scrollTop <= this.autoLoadThreshold;
    },

    isNearMessageListBottom(el) {
      return this.messageListDistanceToBottom(el) <= this.autoLoadThreshold;
    },

    isMessageListScrollable(el) {
      return el.scrollHeight > el.clientHeight + this.autoLoadThreshold;
    },

    updateScrollToBottomButtonVisibility(el) {
      const target = el || this.getMessageListElement();
      this.showScrollToBottomButton = Boolean(
        target &&
          this.messageListDistanceToBottom(target) >
            this.scrollToBottomButtonThreshold
      );
    },

    onMessageListScroll() {
      const el = this.getMessageListElement();
      if (!el) return;

      this.updateScrollToBottomButtonVisibility(el);

      if (
        !this.suppressEarlierHistoryAutoLoad &&
        this.isNearMessageListTop(el)
      ) {
        this.loadEarlierHistory();
      }

      if (this.isNearMessageListBottom(el)) {
        this.loadLaterHistory();
      }
    },

    async handleScrollToBottomClick() {
      await this.loadLatestHistoryFromScrollButton();
    },

    firstCurrentConversationMicrotime() {
      const firstMessage = this.currentVisitor?.conversation?.[0];
      return this.messageDomMicrotime(firstMessage);
    },

    updateEarlierHistoryMetaFromCurrentConversation() {
      const microtime = this.firstCurrentConversationMicrotime();
      this.hasEarlierHistory = Boolean(microtime);
      this.earlierHistoryMicrotime = microtime || null;
    },

    async loadEarlierHistoryUntilScrollable() {
      let el = this.getMessageListElement();
      let loadCount = 0;

      while (
        el &&
        !this.isMessageListScrollable(el) &&
        this.hasEarlierHistory &&
        loadCount < 3
      ) {
        const loaded = await this.loadEarlierHistory();
        if (!loaded) break;
        await this.$nextTick();
        el = this.getMessageListElement();
        loadCount += 1;
      }
    },

    async loadLatestHistoryFromScrollButton() {
      if (!this.currentVisitor || this.loadingLatestHistory) {
        return;
      }

      this.loadingLatestHistory = true;
      const previousSuppressEarlierHistoryAutoLoad =
        this.suppressEarlierHistoryAutoLoad;
      this.suppressEarlierHistoryAutoLoad = true;

      try {
        this.updateEarlierHistoryMetaFromCurrentConversation();
        this.hasLaterHistory = false;
        this.laterHistoryMicrotime = null;

        await this.scrollMessageListToBottomAfterLayout();
        this.historyConversation = [];
        await this.scrollMessageListToBottomAfterLayout();
        this.showScrollToBottomButton = false;
      } finally {
        this.suppressEarlierHistoryAutoLoad =
          previousSuppressEarlierHistoryAutoLoad;
        this.loadingLatestHistory = false;
      }

      await this.loadEarlierHistoryUntilScrollable();
      await this.scrollMessageListToBottomAfterLayout();
    },

    async loadEarlierHistory(options = {}) {
      if (
        !this.currentVisitor ||
        !this.hasEarlierHistory ||
        this.loadingEarlierHistory
      ) {
        return false;
      }

      if (this.messageListTopSpacerHeight) {
        this.messageListTopSpacerHeight = 0;
        await this.$nextTick();
      }

      const el = this.getMessageListElement();
      const anchor = el ? this.messageListAnchor(el) : null;
      const previousScrollHeight = el?.scrollHeight ?? 0;
      const previousScrollTop = el?.scrollTop ?? 0;
      const microtime =
        Object.prototype.hasOwnProperty.call(options, "microtime")
          ? options.microtime
          : this.earlierHistoryMicrotime || undefined;
      const includeCursor = options.includeCursor || 0;

      this.loadingEarlierHistory = true;
      try {
        const loaded = await this.getHistory(microtime, "early", includeCursor);

        if (loaded && options.preserveScroll !== false && el) {
          await this.restoreMessageListAnchor(
            el,
            anchor,
            previousScrollHeight,
            previousScrollTop
          );
        } else {
          await this.$nextTick();
        }

        return loaded;
      } finally {
        this.loadingEarlierHistory = false;
      }
    },

    async loadLaterHistory() {
      if (
        !this.currentVisitor ||
        !this.hasLaterHistory ||
        this.loadingLaterHistory
      ) {
        return false;
      }

      const microtime =
        this.laterHistoryMicrotime || this.lastHistoryMessageMicrotime();
      if (!microtime) {
        this.hasLaterHistory = false;
        this.laterHistoryMicrotime = null;
        return false;
      }

      const el = this.getMessageListElement();
      const previousScrollTop = el?.scrollTop ?? 0;

      this.loadingLaterHistory = true;
      try {
        const loaded = await this.getHistory(microtime, "later");
        if (loaded && el) {
          await this.restoreMessageListScrollTop(el, previousScrollTop);
        } else {
          await this.$nextTick();
        }
        return loaded;
      } finally {
        this.loadingLaterHistory = false;
      }
    },

    /** 点击失败气泡上的 error 图标后，按原 cmicrotime 重发 */
    resendMessage(tempMsg) {

      if (!tempMsg || tempMsg.sendingStatus !== "error") return;
      if (!tempMsg.body) {
        Toast.fail("无法重发该消息");
        return;
      }

      const { uid, cmicrotime, platform, type } = tempMsg;



      this.$store.commit("RESET_SEND_STATUS", { uid, cmicrotime });

      const msg = {
        cmd: "worker",
        body:
          typeof tempMsg.body === "string"
            ? tempMsg.body
            : JSON.stringify(tempMsg.body),
        uid,
        cmicrotime,
      };

      if (platform === "web") {
        msg.type = type || "website";
        msg.platform = platform;
      } else {
        msg.platform = platform;
      }

      const Commet = CommetFactory(this.$store);

      Commet.send(msg);
    },

    editLead() {
      this.$router.push({
        path: "/edit-lead",
        query: {
          uid: this.currentVisitor.uid,
        },
      });
    },

    onTransfer(val) {
      this.showTransferPicker = false;
      transfer({
        uid: this.currentVisitor.uid,
        platform: this.currentVisitor.rawPlatform,
        new_worker_name: val.value,
      }).subscribe(
        () => {
          Toast.success("转接成功");
          this.$router.replace(`/chat-list`);
        },
        () => {
          this.$router.replace(`/chat-list`);
        }
      );
    },

    openTransfer() {
      this.showTransferPicker = true;
      getOnlineWorkers().subscribe((list) => {
        this.workerList = list
          .filter((worker) => {
            return worker.name !== localStorage.getItem("workername");
          })
          .map((worker) => {
            return {
              text:
                worker.name +
                " " +
                worker.nickname +
                `${worker.online ? "" : "(手机在线)"}`,
              value: worker.name,
            };
          });
      });
    },

    report() {
      this.showReportDialog = true;
    },

    doReport() {
      callReport({
        uid: this.currentVisitor.uid,
        reason: "手机端举报",
        platform: this.currentVisitor.platform,
        ip: this.currentVisitor.ip || undefined,
        blocked: this.isReportAndBlock ? 1 : 0,
        reported: this.isReportLegal ? 1 : 0,
      }).subscribe(() => {
        Notify({ type: "success", message: "操作成功" });
        this.showReportDialog = false;

        if (this.isReportAndBlock) {
          this.$router.replace("/chat-list");
        }
      });
    },
  },
});
</script>

<style lang="less" scoped>
.left-container {
  color: #ddd;
  opacity: 1;
  display: flex;
  align-items: center;

  .return-text {
    margin-left: -3px;
  }
}

.title-slot {
  display: flex;
  flex-direction: column;
  line-height: 0;

  i.iconfont {
    font-size: 11px;
    line-height: 15px;
  }

  .title-container {
    line-height: 20px;
    font-size: 16px;
    text-align: center;
  }
}

.message-list {
  padding: 10px;
  padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2+ */
  position: absolute;
  top: 96px;
  bottom: 50px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: auto;
  max-height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-anchor: none;
  box-sizing: border-box;
}

.scroll-to-bottom-button {
  position: fixed;
  right: 18px;
  z-index: 20;
  width: 56px;
  height: 56px;
  padding: 0;
  color: #2f3640;
  background: #fff;
  border: 1px solid #e1e5ea;
  border-radius: 50%;
  box-shadow: 0 10px 28px rgba(32, 38, 46, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-to-bottom-button:active {
  background: #f7f8fa;
}

.scroll-to-bottom-icon-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transform: translateY(1px);
}

.scroll-to-bottom-icon-stack .van-icon {
  height: 14px;
  font-size: 18px;
  line-height: 14px;
  font-weight: 700;
}

.scroll-to-bottom-icon-stack .van-icon + .van-icon {
  margin-top: -6px;
}

.top-action-panel {
  height: 50px;
  background-color: white;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  text-align: center;

  .top-action {
    flex: 1;
    text-align: center;
    font-size: 14px;
  }

  .top-action:last-child {
    border-left: 1px solid #ddd;
  }

  .top-action:first-child {
    border-right: 1px solid #ddd;
  }
}
</style>
